import React, { useState, useEffect } from 'react';
import {
  ShieldCheck,
  ArrowRight,
  CheckCircle2,
  XCircle,
  CreditCard,
} from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import './getpanverify.css';
import '../styles/data-table.css';

const detailFields = [
  { key: 'fullName', label: 'Full Name' },
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'pan', label: 'PAN' },
  { key: 'dob', label: 'Date of Birth' },
  { key: 'gender', label: 'Gender' },
  { key: 'aadhaarLinked', label: 'Aadhaar Linked' },
  { key: 'maskedAadhaarNumber', label: 'Masked Aadhaar' },
  { key: 'address', label: 'Address' },
];

const GetPanVerify = () => {
  const [mobile, setMobile] = useState('');
  const [refStr, setRefStr] = useState('');
  const [responseMsg, setResponseMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      try {
        const decoded = atob(token);
        const parts = decoded.split('|');

        if (parts.length === 2) {
          setRefStr(parts[0]);
          setMobile(parts[1]);
        }
      } catch (e) {
        console.error('Token decode error:', e);
      }
    }
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg('');

    try {
      const apiUrl =
        `https://mrrupya.in/Api/TaskApi/getLeadInfo?lead_id=${refStr}&pan_number=${mobile}`;

      const res = await fetch(apiUrl);
      const text = await res.text();

      console.log('API Response:', text);
      setResponseMsg(text);
    } catch (error) {
      console.error('Error fetching API:', error);
      setResponseMsg('Something went wrong while verifying PAN.');
    } finally {
      setLoading(false);
    }
  };

  const renderResponse = () => {
    if (!responseMsg) return null;

    try {
      const parsed = JSON.parse(responseMsg);
      console.log('Parsed Response:', parsed);

      if (parsed.status === true) {
        return (
          <ScrollReveal className="gpv-result gpv-result--success" y={24}>
            <div className="gpv-result-icon gpv-result-icon--success">
              <CheckCircle2 size={48} strokeWidth={2} aria-hidden="true" />
            </div>
            <h3>Verification successful</h3>
            <p>Your PAN has been successfully verified.</p>

            {parsed.data && (
              <div className="mr-table-wrap">
                <table className="mr-data-table mr-data-table--vertical">
                  <tbody>
                    {detailFields.map(({ key, label }) =>
                      parsed.data[key] ? (
                        <tr key={key}>
                          <th scope="row">{label}</th>
                          <td>{parsed.data[key]}</td>
                        </tr>
                      ) : null
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </ScrollReveal>
        );
      }

      return (
        <ScrollReveal className="gpv-result gpv-result--error" y={24}>
          <div className="gpv-result-icon gpv-result-icon--error">
            <XCircle size={48} strokeWidth={2} aria-hidden="true" />
          </div>
          <h3>Verification failed</h3>
          <p>
            The PAN number you entered is invalid or does not match our records.
            Please check and try again.
          </p>
        </ScrollReveal>
      );
    } catch (e) {
      return (
        <div className="gpv-fallback" role="status">
          <div dangerouslySetInnerHTML={{ __html: responseMsg }} />
        </div>
      );
    }
  };

  return (
    <section className="gpv-section" id="pan-verify">
      <div className="gpv-bg" aria-hidden="true">
        <div className="gpv-bg-gradient" />
        <div className="gpv-bg-dots" />
        <span className="gpv-bg-orb gpv-bg-orb--1" />
        <span className="gpv-bg-orb gpv-bg-orb--2" />
      </div>

      <div className="gpv-wrap">
        <ScrollReveal className="gpv-hero" y={28}>
          <span className="gpv-eyebrow">Identity verification</span>
          <h1 className="gpv-title">
            Verify your <span>PAN details</span>
          </h1>
          <p className="gpv-lead">
            Confirm your PAN information securely to continue your loan process.
          </p>
          <ul className="gpv-highlights">
            <li>
              <ShieldCheck size={16} strokeWidth={2.2} aria-hidden="true" />
              Secure verification
            </li>
            <li>
              <CreditCard size={16} strokeWidth={2.2} aria-hidden="true" />
              Instant PAN check
            </li>
          </ul>
        </ScrollReveal>

        <ScrollReveal className="gpv-card" y={36}>
          <div className="gpv-card-head">
            <CreditCard size={22} strokeWidth={2} aria-hidden="true" />
            <div>
              <h2>PAN verification</h2>
              <p>Your PAN is pre-filled from the verification link. Click submit to verify.</p>
            </div>
          </div>

          <form onSubmit={handleSearch} className="gpv-form">
            <div className="gpv-input-wrap">
              <label htmlFor="pan-number" className="gpv-label">
                PAN number
              </label>
              <input
                id="pan-number"
                type="text"
                className="gpv-input"
                placeholder="Enter your PAN number"
                value={mobile}
                readOnly
                maxLength="10"
                required
              />
            </div>
            <input type="hidden" name="lead_id" value={refStr} />

            <button type="submit" className="gpv-submit-btn" disabled={loading}>
              {loading ? 'Verifying…' : 'Verify PAN'}
              {!loading && <ArrowRight size={18} aria-hidden="true" />}
            </button>
          </form>
        </ScrollReveal>

        {renderResponse()}
      </div>
    </section>
  );
};

export default GetPanVerify;
